import { render, staticRenderFns } from "./microBarChart.vue?vue&type=template&id=aa4978c0&scoped=true"
import script from "./microBarChart.vue?vue&type=script&lang=js"
export * from "./microBarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa4978c0",
  null
  
)

export default component.exports